import { CancelSurveySubscriptionType } from '@griply/types';

import {
  SubscriptionCard,
  SubscriptionCardKind,
  SubscriptionStatus,
} from './get-subscription-cards';

export const getCancellableSubscriptionCard = (
  cards: SubscriptionCard[],
): SubscriptionCard | null =>
  cards.find(
    (card) =>
      card.kind === SubscriptionCardKind.Subscription &&
      card.status !== SubscriptionStatus.Canceled &&
      card.status !== SubscriptionStatus.TrialExpired,
  ) ?? null;

export const getCancelSurveySubscriptionType = (
  card: SubscriptionCard,
): CancelSurveySubscriptionType =>
  card.status === SubscriptionStatus.Trial
    ? CancelSurveySubscriptionType.Trial
    : CancelSurveySubscriptionType.Paid;
